export default __webpack_public_path__ + "static/media/solana.b612f140.svg";